document.addEventListener("DOMContentLoaded", function() {
    let upsellDrawerOpen = false;
    let uniqueMainProductIdentifier = null;

    const editButton = document.querySelector('.edit-button');
    const personalizeButton = document.querySelector('.product-form__submit');
    const personalizeButtonSticky = document.querySelector('button[form="ProductForm-template--15645362225200__main-product"]:not(.product-form__submit)');
    const personalizationForm = document.getElementById("personalizedPlateForm");

    if (editButton) {
        editButton.style.display = 'none'; // Hide the edit button initially
    } else {
        console.error("Edit button not found.");
    }

    function checkAndUpdateButtonState() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const upsellButtons = document.querySelectorAll('button.button.button--primary.button--small.icon-with-text[data-variant-id]');
                if (upsellButtons.length > 0) {
                    upsellButtons.forEach(button => {
                        const variantId = button.getAttribute('data-variant-id');
                        const isProductInCart = cart.items.some(item => item.variant_id.toString() === variantId && item.properties && item.properties.productLinkId === uniqueMainProductIdentifier);
                        updateButton(button, isProductInCart);
                    });
                    updateFormVisibility(cart);
                } else {
                    console.warn("No upsell buttons found on the page.");
                }
            }).catch(error => console.error("Error fetching cart data:", error));
    }

    function updateButton(button, isInCart) {
        const btnTextSpan = button.querySelector('.btn-text');
        if (btnTextSpan) {
            if (isInCart) {
                button.disabled = true;
                btnTextSpan.innerHTML = 'Added ✔';
            } else {
                button.disabled = false;
                btnTextSpan.innerHTML = `
                    <svg class="icon icon-plus icon-2xs" viewBox="0 0 12 12" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M2.5 6H6M9.5 6H6M6 6V2.5M6 6V9.5"></path>
                    </svg>
                    <span class="hidden md:block" data-sold-out="Sold Out">Add</span>
                `;
            }
        } else {
            console.error("Button text span not found for button:", button);
        }
    }

    function updateFormVisibility(cart) {
        const mainProduct = cart.items.find(item =>
            item.variant_id === mainProductId &&
            item.properties &&
            item.properties.productLinkId === uniqueMainProductIdentifier
        );

        const numberPlateUpsell = cart.items.find(item =>
            item.handle === "number-plate-addon" &&
            item.properties &&
            item.properties.productLinkId === uniqueMainProductIdentifier
        );

        if (mainProduct && numberPlateUpsell) {
            if (personalizationForm) {
                personalizationForm.style.display = 'block';
                loadPersonalizationData(mainProduct);
            }
        } else {
            if (personalizationForm) {
                personalizationForm.style.display = 'none';
            }
        }
    }

    function generateUniqueMainProductIdentifier() {
        uniqueMainProductIdentifier = mainProductId + "-" + new Date().getTime();
        console.log("Unique identifier generated for main product:", uniqueMainProductIdentifier);
    }

    function handlePersonalizeClick() {
        generateUniqueMainProductIdentifier();
    }

    if (personalizeButton) {
        personalizeButton.addEventListener('click', handlePersonalizeClick);
    }

    if (personalizeButtonSticky) {
        personalizeButtonSticky.addEventListener('click', handlePersonalizeClick);
    }

    document.addEventListener("variant:change", function(evt) {
        if (evt.detail.variant && evt.detail.variant.id) {
            mainProductId = evt.detail.variant.id;
            generateUniqueMainProductIdentifier();
            checkAndUpdateButtonState();
            checkEditButtonVisibility();
        }
    });

    document.addEventListener("ajaxProduct:added", function(evt) {
        if (evt.detail.product.handle === "number-plate-addon") {
            showPersonalizedPlateForm(mainProductId);
            addUpsellProductToCart(evt.detail.product.id);
            resetPersonalizationForm();
            setTimeout(checkAndUpdateButtonState, 1000); // Delay checking personalization form visibility
        } else {
            openUpsellDrawer();
            addUpsellProductToCart(evt.detail.product.id);
        }
        checkEditButtonVisibility();
    });

    function openUpsellDrawer() {
        const upsellIndicator = document.getElementById('UpsellIndicator');
        if (upsellIndicator && upsellIndicator.dataset.upsellProductsAvailable === "true") {
            const upsellDrawer = document.querySelector("#UpsellDrawer");
            if (upsellDrawer) {
                upsellDrawer.removeAttribute("hidden");
                upsellDrawer.setAttribute("open", "");
                document.body.classList.add("drawer-open");
                upsellDrawerOpen = true;

                upsellDrawer.addEventListener("drawer:afterHide", () => {
                    document.body.classList.remove("drawer-open");
                    upsellDrawerOpen = false;
                }, { once: true });

                checkAndUpdateButtonState();
            }
        } else {
            console.log("No upsells available, upsell drawer will not open.");
        }
    }

    async function addUpsellProductToCart(mainProductId) {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const cartItem = cart.items.find(item => item.id === mainProductId || item.variant_id === mainProductId);
                if (cartItem) {
                    if (uniqueMainProductIdentifier) {
                        const lineIndex = cart.items.indexOf(cartItem) + 1;
                        const properties = { productLinkId: uniqueMainProductIdentifier };
                        updateProductInCart(lineIndex, properties)
                            .then(updatedCart => {
                                console.log("Upsell product linked successfully with unique main product ID:", uniqueMainProductIdentifier);
                                checkAndUpdateButtonState();
                                checkEditButtonVisibility();
                            })
                            .catch(error => console.error("Error updating upsell product in cart:", error));
                    } else {
                        console.error("Unique main product identifier is not set. Cannot link upsell product.");
                    }
                } else {
                    console.error("Upsell product not found in cart:", mainProductId);
                }
            }).catch(error => console.error("Error fetching cart data:", error));
    }

    function showPersonalizedPlateForm(mainProductId) {
        if (personalizationForm) {
            personalizationForm.style.display = "block";
        } else {
            console.error("Personalized plate form element not found.");
        }
    }

    document.addEventListener('cart:updated', function(evt) {
        const cart = evt.detail.cart;

        cart.items.forEach(item => {
            if (item.properties && item.properties.productLinkId && item.properties["Customised Number Plate"] && item.properties["Customised Number Plate Back"] && item.properties.Design) {
                const productLinkIdId = item.properties.productLinkId;
                const personalizationOptionProduct = cart.items.find(cartItem => cartItem.variant_id === 40791493115952 && cartItem.properties.productLinkId === productLinkIdId);

                if (!personalizationOptionProduct) {
                    console.log("Personalization option product not found for main product:", item);
                    removePersonalizationOptions(cart, item.key, productLinkIdId);
                }
            }
        });

        checkEditButtonVisibility();
    });

    function removePersonalizationOptions(cart, itemKey, productLinkIdId) {
        const cartItem = cart.items.find(item => item.key === itemKey);
        if (cartItem) {
            const properties = { ...cartItem.properties };
            delete properties["Customised Number Plate"];
            delete properties["Customised Number Plate Back"];
            delete properties.Design;
            const lineIndex = cart.items.indexOf(cartItem) + 1;
            updateProductInCart(lineIndex, properties)
                .then(() => {
                    console.log("Personalization options removed successfully.");
                })
                .catch(error => console.error("Error removing personalization options:", error));
        } else {
            console.error("Item not found in cart:", itemKey);
        }
    }

    function updateProductInCart(lineIndex, properties) {
        const sectionsToUpdate = [];

        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement) {
            sectionsToUpdate.push(theme.utils.sectionId(cartDrawerElement));
        }

        const cartPageElement = document.querySelector('.cart-page');
        if (cartPageElement) {
            sectionsToUpdate.push(theme.utils.sectionId(cartPageElement));
        }

        const body = JSON.stringify({
            line: lineIndex,
            properties: properties,
            sections: sectionsToUpdate
        });

        return fetch(theme.routes.cart_change_url, {
            ...theme.utils.fetchConfig(),
            method: 'POST',
            body: body
        }).then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        }).then(updatedState => {
            // Update the cart drawer with the updated state
            if (cartDrawerElement) {
                const cartElement = cartDrawerElement.querySelector('cart-items');
                const updatedCartElement = new DOMParser().parseFromString(updatedState.sections[theme.utils.sectionId(cartDrawerElement)], 'text/html').querySelector('cart-items');
                if (cartElement && updatedCartElement) {
                    cartElement.innerHTML = updatedCartElement.innerHTML;
                }
            }

            // Update the cart page with the updated state
            if (cartPageElement) {
                const cartItemsElement = cartPageElement.querySelector('.cart-items');
                const updatedCartItemsElement = new DOMParser().parseFromString(updatedState.sections[theme.utils.sectionId(cartPageElement)], 'text/html').querySelector('.cart-items');
                if (cartItemsElement && updatedCartItemsElement) {
                    cartItemsElement.innerHTML = updatedCartItemsElement.innerHTML;
                }
            }

            // Dispatch the 'cart:updated' event
            document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: updatedState
                }
            }));
        });
    }

    function checkEditButtonVisibility() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const matchingProducts = cart.items.filter(item => item.variant_id === mainProductId);

                if (matchingProducts.length > 0) {
                    if (editButton) {
                        editButton.style.display = 'block';
                    }
                } else {
                    if (editButton) {
                        editButton.style.display = 'none';
                    }
                    if (personalizationForm) {
                        personalizationForm.style.display = 'none';
                    }
                }
            }).catch(error => console.error("Error fetching cart data:", error));
    }

    checkEditButtonVisibility();

    function resetPersonalizationForm() {
        document.getElementById("frontInput").value = "";
        document.getElementById("backInput").value = "";
    }

    function loadPersonalizationData(product) {
        if (personalizationForm) {
            personalizationForm.style.display = 'block';
            const personalizationData = product.properties;
            document.getElementById("frontInput").value = personalizationData["Customised Number Plate"] || "";
            document.getElementById("backInput").value = personalizationData["Customised Number Plate Back"] || "";
            document.getElementById("designInput").value = personalizationData.Design || "GB"; // Default to "GB"
            updateDesign(); // Update design preview
        }
    }

    function showProductSelectionMenu(products) {
        const drawerScrollable = document.querySelector('#ProductSelectionDrawer .drawer__scrollable');
        drawerScrollable.innerHTML = ''; // Clear previous content

        const groupedProducts = {};

        products.forEach(product => {
            const productLinkId = product.properties.productLinkId;
            if (!groupedProducts[productLinkId]) {
                groupedProducts[productLinkId] = {
                    product_title: product.product_title,
                    variant_title: product.variant_title,
                    image: product.image,
                    properties: product.properties
                };
            }
        });

        Object.values(groupedProducts).forEach(product => {
            const productContainer = document.createElement('div');
            productContainer.classList.add('product-container', 'flex', 'items-start', 'md:items-center', 'gap-3', 'md:gap-4', 'relative', 'z-1');

            const productImage = document.createElement('img');
            productImage.src = product.image;
            productImage.classList.add('w-20', 'h-20', 'object-cover', 'rounded');
            productContainer.appendChild(productImage);

            const productInfo = document.createElement('div');
            productInfo.classList.add('product-info', 'flex-grow', 'flex', 'flex-col');
            productInfo.innerHTML = `
                <p class="font-medium text-lg md:text-xl leading-tight">${product.product_title} | ${product.variant_title}</p>
            `;

            if (product.properties && product.properties["Customised Number Plate"] && product.properties["Customised Number Plate Back"]) {
                const personalizationInfo = document.createElement('div');
                personalizationInfo.classList.add('personalization-info', 'mt-1', 'text-sm', 'flex', 'flex-col', 'md:flex-row', 'gap-2', 'flex-wrap');
                personalizationInfo.innerHTML = `
                    <p><strong>Front:</strong> ${product.properties["Customised Number Plate"]}</p>
                    <p><strong>Back:</strong> ${product.properties["Customised Number Plate Back"]}</p>
                    <p><strong>Design:</strong> ${product.properties.Design || 'N/A'}</p>
                `;
                productInfo.appendChild(personalizationInfo);
            }

            productContainer.appendChild(productInfo);

            const editButton = document.createElement('button');
            editButton.classList.add('button', 'dynamic-edit-button', 'ml-auto');
            editButton.setAttribute('is', 'hover-button'); // Add the 'is' attribute
            editButton.textContent = 'Edit';
            editButton.addEventListener('click', () => {
                uniqueMainProductIdentifier = product.properties.productLinkId;
                openUpsellDrawer();
                checkAndUpdateButtonState();
                loadPersonalizationData(product);
                closeProductSelectionDrawer();
            });
            productContainer.appendChild(editButton);

            drawerScrollable.appendChild(productContainer);
        });

        // Show the drawer
        openProductSelectionDrawer();
    }

    function delay(fn, ms) {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(fn.bind(this, ...args), ms || 0);
        };
    }

    let statusTimer; // Variable to hold the timer for the delayed status message

    function showStatusMessage(status, message) {
        const statusMessageElement = document.getElementById('formStatusMessage');
        if (statusMessageElement) {
            statusMessageElement.innerHTML = `<div class="alert alert--${status}">${message}</div>`;
            setTimeout(clearStatusMessage, 10000); // Hide message after 10 seconds
        }
    }

    function clearStatusMessage() {
        const statusMessageElement = document.getElementById('formStatusMessage');
        if (statusMessageElement) {
            statusMessageElement.innerHTML = '';
        }
    }

    function savePersonalizationData() {
        clearTimeout(statusTimer); // Clear any existing timer
        showStatusMessage('info', 'Saving...');

        const front = document.getElementById("frontInput").value;
        const back = document.getElementById("backInput").value;
        const design = document.getElementById("designInput").value;

        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const cartItem = cart.items.find(item =>
                    item.variant_id == mainProductId &&
                    item.properties.productLinkId === uniqueMainProductIdentifier
                );

                if (!cartItem) {
                    console.error("Main product not found in cart:", mainProductId);
                    showStatusMessage('error', 'Linking to product...');
                    return;
                }

                const properties = {
                    ...cartItem.properties,
                    "Customised Number Plate": front,
                    "Customised Number Plate Back": back,
                    Design: design,
                    productLinkId: uniqueMainProductIdentifier
                };

                const lineIndex = cart.items.indexOf(cartItem) + 1;

                updateProductInCart(lineIndex, properties)
                    .then(() => {
                        showStatusMessage('success', 'Product customisation updated successfully.');
                        checkEditButtonVisibility();
                    })
                    .catch(error => {
                        console.error("Error updating product in cart:", error);
                        showStatusMessage('error', 'Error updating product in cart.');
                    });
            })
            .catch(error => {
                console.error("Error fetching cart data:", error);
                showStatusMessage('error', 'Error fetching cart data.');
            });
    }

    const delayedSavePersonalizationData = delay(savePersonalizationData, 1000);

    function attachAutoSaveEvents() {
        const frontInput = document.getElementById("frontInput");
        const backInput = document.getElementById("backInput");
        const designInput = document.getElementById("designInput");

        if (frontInput && backInput && designInput) {
            frontInput.addEventListener('input', delayedSavePersonalizationData);
            backInput.addEventListener('input', delayedSavePersonalizationData);
            designInput.addEventListener('change', delayedSavePersonalizationData);
        } else {
            console.error("One or more input elements not found.");
        }
    }

    // Initialize the form and attach auto-save events
    attachAutoSaveEvents();

    function openProductSelectionDrawer() {
        const drawer = document.querySelector('#ProductSelectionDrawer');
        if (drawer) {
            drawer.removeAttribute('hidden');
            drawer.setAttribute('open', '');
            document.body.classList.add('drawer-open');

            drawer.addEventListener('drawer:afterHide', () => {
                document.body.classList.remove('drawer-open');
                drawer.removeAttribute('open');
            }, { once: true });
        }
    }

    function closeProductSelectionDrawer() {
        const drawer = document.querySelector('#ProductSelectionDrawer');
        if (drawer) {
            drawer.removeAttribute('open');
            document.body.classList.remove('drawer-open');
        }
    }

    let editButtonListenerAttached = false;

    if (editButton) {
        if (!editButtonListenerAttached) {
            editButton.addEventListener('click', function() {
                fetch("/cart.js")
                    .then(response => response.json())
                    .then(cart => {
                        const matchingProducts = cart.items.filter(item => item.variant_id === mainProductId);
                        if (matchingProducts.length > 0) {
                            if (matchingProducts.length > 1) {
                                console.log("Multiple matching products found, showing selection menu.");
                                showProductSelectionMenu(matchingProducts);
                            } else {
                                console.log("Single matching product found, setting uniqueMainProductIdentifier and opening upsell drawer.");
                                uniqueMainProductIdentifier = matchingProducts[0].properties.productLinkId;
                                openUpsellDrawer();
                                checkAndUpdateButtonState();
                            }
                        } else {
                            console.warn("No matching products found in cart for variant_id:", mainProductId);
                        }
                    }).catch(error => console.error("Error fetching cart data:", error));
            });
            editButtonListenerAttached = true;
        }
    }

    checkAndUpdateButtonState();  // Initial check on page load
});
